// Module
var code = "<icon mimetype=\"$ctrl.attachment.mimetype\"></icon> <a href ng-click=\"$ctrl.download()\"> {{ $ctrl.attachment.name }} </a> <span class=\"mail-attachment-size\"> {{ $ctrl.attachment.data.length | humanSize }} </span> ";
// Exports
export default code;